module.exports = __webpack_public_path__ + "officialStatic/img/case-lx.a75a0ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case-lx.png
// module id = 8pkL
// module chunks = 0